<script setup>
const props = defineProps(['data']);
const type = ref(props.data.type.toLowerCase().replace('_', '-'));
</script>

<template>
  <span class="feature-icon">
    <i :class="[`icon-${type}`]" :title="data.title" />
  </span>
</template>

<style lang="scss" scoped>
.feature-icon {
  margin-right: 0.5em;
  font-size: 20px;
}
</style>
